"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayerSwitchControl = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const useKatastrMap_1 = require("../../../useKatastrMap");
const react_ui_1 = require("@pasport/react-ui");
function LayerSwitchControl({ map }) {
    const { active: isKatastr } = (0, useKatastrMap_1.useStayKatastrMap)();
    const { setKatastr, setGeo } = (0, useKatastrMap_1.useKatastrMap)(map);
    const onChange = (value) => {
        if (!isKatastr) {
            setKatastr();
        }
        else {
            setGeo();
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(react_ui_1.Checkbox, { variant: "switch", checked: isKatastr, onChange: onChange, label: "Katastr\u00E1ln\u00ED mapa" }) }));
}
exports.LayerSwitchControl = LayerSwitchControl;
